enum ActionType {
    LOGGING_IN = '[SESSION-DATA] LOGGING_IN',
    LOGGED_IN = '[SESSION-DATA] LOGGED IN',
    ERROR_OCCURED = '[SESSION-DATA] ERROR OCCURED',
    LOGGING_OUT = '[SESSION-DATA] LOGGING OUT',
    LOGGED_OUT = '[SESSION-DATA] LOGGED OUT',
}

export default ActionType
